import { render, staticRenderFns } from "./CoreSelectRole.vue?vue&type=template&id=443b8316"
import script from "./CoreSelectRole.vue?vue&type=script&lang=js"
export * from "./CoreSelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports